import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { NEXT_STATIC_IMAGES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import styles from './TeamValuesGrid.module.scss';

const valuesList = [
  { id: 0, src: 'row-together', svgHeight: 55 },
  { id: 1, src: 'be-captain', svgHeight: 80 },
  { id: 2, src: 'bring-joy', svgHeight: 80 },
];

const TeamValuesGrid: FC = () => {
  const [t] = useTranslation('about-page');

  return (
    <PitchPageLayout backgroundColor="pearl">
      <div className={styles.root}>
        <section>
          <div className={styles.title}>
            <Typography
              type="h2"
              size="display-4"
            >
              {t('values--title')}
            </Typography>
          </div>
          <ul className={styles.valuesList}>
            {valuesList.map((value) => (
              <li key={value.id} className={styles.valuesListItem}>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={`${NEXT_STATIC_IMAGES}about/${value.src}.svg`}
                  width={value.svgHeight}
                  height={80}
                  alt={t(`values--${value.id}--name`)}
                  loading="lazy"
                />
                <div className={styles.valueName}>
                  <Typography
                    type="h3"
                    size="heading-5"
                    weight="semibold"
                  >
                    {t(`values--${value.id}--name`)}
                  </Typography>
                </div>
                <Typography
                  type="p"
                  size="body-xl"
                >
                  {t(`values--${value.id}--description`)}
                </Typography>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </PitchPageLayout>
  );
};

export default TeamValuesGrid;
